module.exports = __webpack_public_path__ + "img/banner-bg3 1.ad8e051f.png";